<template>
  <div class="d-flex justify-center align-center fill-height">
    <v-card class="elevation-5" min-width="500">
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ $t('general.welcome', {appName: $properties.appTitle}) }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-form>
        <v-card-text>
          <v-alert v-if="errorMessage.length > 0" type="error">{{ errorMessage }}</v-alert>

          <v-text-field
            v-model="email"
            :label="$t('auth.email')"
            :placeholder="$t('auth.email')"
            name="email"
            prepend-icon="mdi-account"
            type="text"
            validate-on-blur
            autocomplete="username"
            :disabled="loading"
          ></v-text-field>

          <v-text-field
            v-model="password"
            id="password"
            :label="$t('auth.password')"
            :placeholder="$t('auth.password')"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
            @keyup.enter.native="submit"
            autocomplete="current-password"
            :disabled="loading"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            block
            x-large
            @click="submit"
            :disabled="loading"
            :loading="loading"
          >{{ $t('auth.login') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import {RouterUtils} from '../utils/router-utils';
import {mapGetters} from 'vuex';
import {MainUtils} from '@/utils/main-utils';

export default {
  name: 'LoginPage',
  mixins: [
    MainUtils,
    RouterUtils
  ],
  data: () => ({
    email: null,
    password: null,
    overlay: false,
    errorMessage: '',
    loading: false
  }),

  computed: {
    ...mapGetters({
      isAuthenticated: 'isAuthenticated'
    }),
    pageTitle () {
      return this.$t('auth.login');
    }
  },

  methods: {
    submit () {
      this.loading = true;
      this.$auth.login({
        email: this.email,
        password: this.password
      })
      .catch(reason => {
        console.error(reason);
        this.errorMessage = this.getErrorMessageByResponse(reason);
      })
      .finally(() => {
        this.loading = false;
      });
    },
  },
}
</script>
